export default function MurfreesboroDestinationsSection() {
  const destinations = [
    {
      city: "United Kingdom",
      flag: "🇬🇧",
      reason: "Study Abroad",
      detail: "MTSU has exchange programs with UK universities. London, Edinburgh, and Manchester are popular semester destinations.",
      flight: "8-9 hrs from BNA",
    },
    {
      city: "Spain",
      flag: "🇪🇸",
      reason: "Student Programs",
      detail: "Madrid and Barcelona are top MTSU study abroad destinations. We handle student visa documentation alongside passports.",
      flight: "9-10 hrs from BNA",
    },
    {
      city: "Mexico",
      flag: "🇲🇽",
      reason: "Spring Break",
      detail: "Cancun and Playa del Carmen are favorite spring break spots for MTSU students. We offer student group processing.",
      flight: "3-4 hrs from BNA",
    },
    {
      city: "France",
      flag: "🇫🇷",
      reason: "Study Abroad",
      detail: "Paris and Lyon host MTSU exchange students. We understand French student visa requirements and timelines.",
      flight: "9-10 hrs from BNA",
    },
    {
      city: "Italy",
      flag: "🇮🇹",
      reason: "Business & Leisure",
      detail: "Nashville music industry professionals and MTSU students alike travel to Rome, Milan, and Florence year-round.",
      flight: "10-12 hrs from BNA",
    },
    {
      city: "Japan",
      flag: "🇯🇵",
      reason: "Nissan Business",
      detail: "Nissan Smyrna employees frequently travel to Japan for corporate meetings. We handle business passport documentation.",
      flight: "14-16 hrs from BNA",
    },
  ];

  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Popular Destinations</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Murfreesboro Travelers Go
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From MTSU study abroad programs to Nashville business travel, we prepare passports for every journey.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {destinations.map((dest, index) => (
            <div key={index} className="bg-white rounded-xl p-6 border border-gray-100 hover:border-[#F6C344] transition-all">
              <div className="flex items-center gap-3 mb-4">
                <span className="text-3xl">{dest.flag}</span>
                <div>
                  <h3 className="font-serif text-lg font-bold text-[#1A365D]">{dest.city}</h3>
                  <span className="text-[#F6C344] text-xs font-semibold uppercase">{dest.reason}</span>
                </div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{dest.detail}</p>
              <div className="flex items-center gap-2 text-xs text-gray-400 bg-[#F7F8FA] px-3 py-2 rounded-lg">
                <i className="ri-flight-takeoff-line"></i>
                <span>{dest.flight}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}